module.exports = __webpack_public_path__ + "img/info.995bc5af.png";